import { MatchEventIconTypes } from '@sport1/news-styleguide/Types'
import { MatchEventClientModel } from '@sport1/types/sportData'

const getEventIconType = ({
    eventType,
    subType,
}: Pick<MatchEventClientModel, 'subType' | 'eventType'>): MatchEventIconTypes | undefined => {
    if (eventType === 'RED_CARD') {
        return subType === 'SECOND_YELLOW' ? 'SECOND_YELLOW_CARD' : 'RED_CARD'
    } else if (eventType === 'PENALTY_SHOT') {
        return subType === 'SAVED' || subType === 'MISSED' ? 'PENALTY_MISSED' : 'PENALTY_SCORED'
    } else if (eventType === 'MISSED_PENALTY') {
        return 'PENALTY_MISSED'
    } else if (
        eventType &&
        ['GOAL', 'YELLOW_CARD', 'SUBSTITUTION', 'MISSED_PENALTY'].includes(eventType as string)
    ) {
        return eventType as MatchEventIconTypes
    }
}

export default getEventIconType
